import { render, staticRenderFns } from "./Compass.vue?vue&type=template&id=68363530"
import script from "./Compass.vue?vue&type=script&lang=js"
export * from "./Compass.vue?vue&type=script&lang=js"
import style0 from "./Compass.vue?vue&type=style&index=0&id=68363530&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports